import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedSSRKilometricPrice: {
      priceBreakdowns: [],
      line: {},
      additionalServiceDistanceBasedPricings: [],
    },
  }),

  mutations: {
    setSelectedAdditionalServiceKilometricPrice(state, kilometricPrice) {
      Vue.set(state, "selectedKilometricPrice", kilometricPrice);
    },
  },

  actions: {
    //TODO: load, update, create
    createSSRKilometricPrice: (context, request) => {
      return axios
        .post(
          context.getters.getMcServiceUrl + "/ssr-pricing-periods/get-ssr-distance-based-pricing-by-orer/" + request.selectedOrerId,
          request.ssrDistanceBasedPricingRules,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createSSRPricingPeriods: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/ssr-pricing-periods/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadSSRPricingPeriods: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/entity").then((response) => {
        return response.data;
      });
    },

    loadSSRPricingPeriod: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    sendToApprovalSSRPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/sendToApproval/" + distanceBasedPrice.intentId).then((response) => {
        if (distanceBasedPrice.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "WAITING_APPROVAL";
        } else if (distanceBasedPrice.intents[0].type === "'CREATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallSSRPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/recall/" + distanceBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        helper.recallOrRejectEntity(distanceBasedPrice, "ADDITIONAL_SERVICE_PRICING_PERIOD");
        return response.data;
      });
    },

    cancelSSRPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/cancel/" + distanceBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        return response.data;
      });
    },

    rejectSSRPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/reject/" + distanceBasedPrice.intentId).then((response) => {
        if (distanceBasedPrice.intents[0].type === "DELETE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents = null;
          distanceBasedPrice.intentId = 0;
        } else if (distanceBasedPrice.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "DRAFT";
        } else if (distanceBasedPrice.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    publishSSRPricingPeriod: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    deleteSSRPricingPeriod: (context, distanceBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/ssr-pricing-periods/entity/" + distanceBasedPrice.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          distanceBasedPrice.intents = intents;
          distanceBasedPrice.intentId = response.data.id;
          return distanceBasedPrice;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    loadSelectedSSRHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/ssr-pricing-periods/history/" + request.id).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedSSRKilometricPrice: (state) => {
      return state.selectedSSRKilometricPrice;
    },
  },
};
